export default __webpack_public_path__ + "static/media/pokeball.a835fb9b.png";